export async function resizeImage(global: Window, src: string): Promise<string> {
  const image = new Image();
  const data = await new Promise<string>((resolve) => {
    image.onload = () => {
      // from google OCR docs: TEXT_DETECTION and DOCUMENT_TEXT_DETECTION	require 1024 x 768 image size
      const { width, height } = calculateAspectRatioFit(image.width, image.height, 1024, 768);
      const canvas = global.document.createElement('canvas') as HTMLCanvasElement;
      const ctx = canvas.getContext('2d');
      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(image, 0, 0, width, height);
      const data = canvas.toDataURL('image/jpeg');
      canvas.remove();

      resolve(data);
    };
    image.src = src;
  });
  image.remove();
  return data;
}

function calculateAspectRatioFit(
  srcWidth: number,
  srcHeight: number,
  maxWidth: number,
  maxHeight: number
): { width: number; height: number; } {

  const ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);

  return { width: srcWidth*ratio, height: srcHeight*ratio };
}
